import api from '../../services/faq';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('faq');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({
    // Overwrite the getOne action to send the extra params without getting an API error
    getOne(context, params) {
      helper.log().info(`[Store: FAQ}]: Get FAQ`, params);
      return new Promise((resolve, reject) => {
        return helper
        .api()
        .getOne(params)
        .then((response) => {
          helper.log().info(`[Store: FAQ]: Got FAQ`, response.data);
          context.commit(types.STORE_GET, {
            params,
            result: response.data.data,
          });
          resolve(response.data.data);
        })
        .catch((error) => {
          helper.log().info(`[Store: FAQ]: Error Getting FAQ`, error);
          reject(error);
        })
      });
    },
  }, 'FAQ');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}